import { Footer } from '../../components/share/Footer';
import { NavbarComponent } from "../../components/share/NavbarComponent";
import { HeadTitle } from "../../components/share/HeadTitle";
import { ConsiderRegisterDetailComponent } from "../../components/RegisterSystem/ConsiderRegisterDetailComponent";
export function ConsiderRegisterDetailContainer() {
    const titleName = "รายละเอียดคำขอลงทะเบียน";
    return (
        <div className="page-container bg-landing">
            <NavbarComponent />
            <HeadTitle title={titleName} />
            <ConsiderRegisterDetailComponent />
            <Footer />
        </div>
    );
}